import React from "react";
import { Icon } from "@iconify/react";
import { ModalComponent, CancelButton, ButtonComponent } from "@comps/components";

/**
 * Confirmation for logging out.
 *
 * Log out used to fire straight off the account menu, so a mis-click on a
 * four-item dropdown ended the session and threw away whatever was open.
 * It now asks, and shows *which* account is about to be signed out —
 * shared clinic machines get more than one.
 */
const LogoutModal = ({ open, user, avatar, loading, onConfirm, onCancel }) => (
  <ModalComponent
    className="base-modal logout-modal"
    icon="tabler:logout"
    mainTitle="Log out"
    subTitle="You'll need to sign in again to get back in"
    open={ open }
    onCancel={ onCancel }
    width="min(440px, calc(100vw - 32px))"
    footer={
      <div className="form-actions">
        <CancelButton key="cancel" onClick={ onCancel } text="Stay signed in" />
        <ButtonComponent
          key="confirm"
          type="primary"
          danger
          autoFocus
          state={ loading }
          onClick={ onConfirm }
        >
          Log out
        </ButtonComponent>
      </div>
    }
  >
    <div className="logout-modal-account">
      <img className="logout-modal-avatar" src={ avatar } alt="" />
      <span className="logout-modal-meta">
        <span className="logout-modal-name">{ user && user.name }</span>
        <span className="logout-modal-email">{ user && user.email }</span>
      </span>
    </div>

    <p className="logout-modal-note">
      <Icon icon="tabler:alert-circle" width={ 16 } />
      Any unsaved changes will be lost.
    </p>
  </ModalComponent>
);

export default LogoutModal;
